class HeaderSearch extends HTMLElement {
  constructor() {
      super();
      this.render();
      this.setupEventListeners();
      this.searchQuery = "";
  }

  render() {
    this.innerHTML = `
        <div class="sidebar-search-container">
            <div class="search-input-wrapper">
                <input 
                    type="text" 
                    class="search-input" 
                    placeholder="SEARCH"
                />
                <!-- 
                <button class="search-button">
                    <img src="${this.getAttribute('icon-url-black')}" alt="Search" />
                </button> 
                -->
            </div>
            <div class="search-results-container">
                <!-- Aquí se mostrarán los resultados -->
            </div>
        </div>
    `;
  }

  setupEventListeners() {


        // --- Reinicializar el input desde cero al montar o al volver atrás ---
        const hardResetInput = () => {
        const oldInput = this.querySelector('.search-input');
        if (oldInput) {
            const parent = oldInput.parentElement;
            const newInput = document.createElement('input');
            newInput.type = 'text';
            newInput.className = 'search-input';
            newInput.setAttribute('autocomplete', 'off');
            newInput.setAttribute('autocorrect', 'off');
            newInput.setAttribute('autocapitalize', 'off');
            newInput.setAttribute('spellcheck', 'false');
            newInput.placeholder = 'SEARCH'; // sin placeholder visible
            newInput.name = 'q_' + Math.random().toString(36).slice(2); // nombre aleatorio
            parent.replaceChild(newInput, oldInput);
        }
        };

        // Llamamos al cargar el componente
        hardResetInput();

        // Y si el navegador restaura la página desde el caché (BFCache)
        window.addEventListener('pageshow', (e) => {
        if (e.persisted) hardResetInput();
        });

      const input = this.querySelector('.search-input');
      const searchButton = this.querySelector('.search-button');

      input.addEventListener('input', () => {
          this.searchQuery = input.value;
          this.searchFor(this.searchQuery);
      });

      input.addEventListener('keydown', async (event) => {
          if (event.key === 'Enter') {
              event.preventDefault();
              await this.handleEnterKey();
          }
      });

      if (searchButton) {
          searchButton.addEventListener('click', () => {
              if (this.searchQuery) {
                  this.searchFor(this.searchQuery);
              }
          });
      }
  }

  async searchFor(searchParam) {
      if (!searchParam.trim()) {
          this.displayResults('');
          return;
      }

      try {
          const response = await fetch(`/search?q=${encodeURIComponent(searchParam)}&type=product`);
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          if (this.searchQuery !== searchParam) return;
          
          // Extraer productos del HTML
          const products = this.parseProductsFromHTML(doc);
          this.displaySearchResults(products);
      } catch (error) {
          console.error('Error searching products:', error);
          this.displayResults('<p>Error al buscar productos.</p>');
      }
  }

  parseProductsFromHTML(doc) {
      const productElements = doc.querySelectorAll('.card-wrapper, .product-card, [data-product-id]');
      const products = [];
      
      productElements.forEach(el => {
          const link = el.querySelector('a[href*="/products/"]');
          const title = el.querySelector('.card__heading, .product-title, h3, h2');
          const img = el.querySelector('img');
          
          // Buscar el precio de forma más específica
          let price = '';
          const priceEl = el.querySelector('.price-item--regular, .price__regular .price-item, .price .price-item');
          if (priceEl) {
              price = priceEl.textContent.trim();
          }
          
          if (link && title) {
              products.push({
                  url: link.href,
                  title: title.textContent.trim(),
                  featured_image: img ? { url: img.src } : null,
                  price: price
              });
          }
      });
      
      return products;
  }

  displaySearchResults(products) {
        const resultsHTML = products.map(product => {
        const price = product.price;
        const [num, currency] = price.split(" ");
        const normalized = num.replace(",", "");
        const numFloat = parseFloat(normalized);

        const priceFormatted = `${numFloat.toLocaleString("de-DE")} ${currency}`;
        
        return `
            <a href="${product.url}" class="search-result-item">
            <div class="product-info">
                ${product.featured_image ? `
                <img src="${product.featured_image.url}" alt="${product.title}" class="product-thumbnail" />
                ` : ''}
                <div class="product-details">
                <h3>${product.title}</h3>
                <p class="product-price">${priceFormatted}</p>
                </div>
            </div>
            </a>
        `;
        }).join('');

        this.displayResults(resultsHTML);
    }

  displayResults(resultsContent) {
      const resultsContainer = this.querySelector('.search-results-container');
      resultsContainer.innerHTML = resultsContent;
  }

  async handleEnterKey() {
      if (!this.lastSearchResults || this.lastSearchResults.length !== 1) {
          // If there's not exactly one result, perform default search
          if (this.searchQuery) {
              window.location.href = `/search?q=${encodeURIComponent(this.searchQuery)}`;
          }
          return;
      }

      const product = this.lastSearchResults[0];
      const productHandle = this.getProductHandleFromUrl(product.url);
      
      if (productHandle) {
          const dropCollection = await this.getProductDropCollection(productHandle);
          if (dropCollection) {
              window.location.href = `/collections/${dropCollection}`;
              return;
          }
      }
      
      // Fallback to product page
      window.location.href = product.url;
  }

  getProductHandleFromUrl(url) {
      const match = url.match(/\/products\/([^?\/]+)/);
      return match ? match[1] : null;
  }

  async getProductDropCollection(productHandle) {
      try {
          const response = await fetch(`/products/${productHandle}.js`);
          const productData = await response.json();
          
          // Find a collection that starts with "drop-"
          if (productData.collections) {
              for (let collection of productData.collections) {
                  if (collection.handle && collection.handle.startsWith('drop-')) {
                      return collection.handle;
                  }
              }
          }
          return null;
      } catch (error) {
          console.error('Error fetching product collections:', error);
          return null;
      }
  }
}

customElements.define('header-search', HeaderSearch);